import Vue from 'vue'
import App from './App.vue'
import Bridge from '@vkontakte/vk-bridge'
import { gtag, install } from 'ga-gtag';

install('G-KRZJ8BS0T0', {
  cookie_flags: 'SameSite=None;Secure',
  cookie_domain: 'vkclips-dev.for.game',
});

Vue.config.productionTip = false

Bridge.send('VKWebAppInit')

window.onload = function () {
  Vue.prototype.$gtag = gtag

  new Vue({
    render: h => h(App),
  }).$mount('#app')

};
